module.exports = __webpack_public_path__ + "media/חול.0024f835.mp3";